import { useEffect, useState } from 'react';

/** Liefert `value` erst, wenn er sich `ms` Millisekunden nicht mehr geändert hat. */
export function useDebounced<T>(value: T, ms: number): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = window.setTimeout(() => setDebounced(value), ms);
    return () => window.clearTimeout(timer);
  }, [value, ms]);

  return debounced;
}
